// src/store/slices/userSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Affiliate {
  id: string;
  nome: string;
  email: string;
  cpf: string;
  telefone?: string;
  foto?: string;
  status: 'ativo' | 'inativo' | 'pendente';
}

interface Student {
  id: string;
  nome: string;
  email: string;
  matricula: string;
  cursos: string[];
}

interface AffiliateStats {
  totalAlunos: number;
  cursosAtivos: number;
  receitaMensal: number;
}

interface UserProfile {
  affiliate?: Affiliate;
  student?: Student;
  stats?: AffiliateStats;
  loading: boolean;
  error: string | null;
}

// FIX: Inicializar com undefined explícito para compatibilidade com exactOptionalPropertyTypes
const initialState: UserProfile = {
  loading: false,
  error: null,
  // Não definir affiliate, student e stats - deixar implicitamente undefined
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAffiliate: (state, action: PayloadAction<Affiliate>) => {
      state.affiliate = action.payload;
      state.loading = false;
    },

    setStudent: (state, action: PayloadAction<Student>) => {
      state.student = action.payload;
      state.loading = false;
    },

    setStats: (state, action: PayloadAction<AffiliateStats>) => {
      state.stats = action.payload;
    },

    updateAffiliatePhoto: (state, action: PayloadAction<string>) => {
      if (state.affiliate) {
        state.affiliate.foto = action.payload;
      }
    },

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },

    clearProfile: (state) => {
      // FIX: Deletar propriedades ao invés de atribuir undefined
      delete state.affiliate;
      delete state.student;
      delete state.stats;
      state.error = null;
    },
  },
});

export const {
  setAffiliate,
  setStudent,
  setStats,
  updateAffiliatePhoto,
  setLoading,
  setError,
  clearProfile,
} = userSlice.actions;

export default userSlice.reducer;
